<template>
  <div class="filter-results">
    <button @click="show = !show">
      הצגת תוצאות לפי <i class="mdi mdi-chevron-down"></i>
    </button>
    <div class="filter-results-options" v-if="show">
      <a href="#" :class="isActive(1)" @click.prevent="selectOption(1)"
        >הכי פופולארי</a
      >
      <a href="#" :class="isActive(2)" @click.prevent="selectOption(2)"
        >חדשים</a
      >
      <a href="#" :class="isActive(6)" @click.prevent="selectOption(6)"
        >לא נצפו</a
      >
      <a href="#" :class="isActive(3)" @click.prevent="selectOption(3)">א-ת</a>
      <a href="#" :class="isActive(4)" @click.prevent="selectOption(4)"
        >סדרות בלבד</a
      >
      <a href="#" :class="isActive(5)" @click.prevent="selectOption(5)"
        >שיעורים בלבד</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { show: false };
  },
  methods: {
    isActive(option) {
      if (this.$store.state.sort.sortby === option) {
        return "active";
      }
      return "";
    },
    selectOption(option) {
      this.$store.dispatch("setSortBy", option);
      this.show = false;
    },
  },
};
</script>

<style lang="scss">
.filter-results {
  position: relative;
  button {
    background-color: transparent;
    border: 0;
    font-size: 1.125rem;
  }
  div {
    position: absolute;
    background-color: #ffffff;
    min-width: 220px;
    z-index: 30;
    padding: 0.5rem;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  }
  a {
    display: block;
    text-align: right;
    font-size: 1.125rem;
    padding: 0.3rem 0.5rem;
    color: #adaaaa;
    border-bottom: 0.3px solid #eeeeee;
    transition: all 0.2s ease;
    cursor: pointer;
    &:hover {
      background-color: #eee;
    }
  }
  .active {
    color: #4c92fb;
    font-weight: bold;
  }
}
</style>
